<template>

	<div>
		<a-result status="403" title="到期" sub-title="很抱歉, 您的店铺已经过期,请联系技术人员续费">
		    <template #extra>
				<img src="../assets/image/erweima.jpg"  class="custom-icon" />
		      <router-link to="/mendian">
		      <a-button type="primary">
		        返回
		      </a-button>
		      </router-link>
		    </template>
			<template #icon>
				<!-- 这里插入自定义图片 -->
				<img src="../assets/image/erweima.jpg"  class="custom-icon" />
			  </template>
		  </a-result>
	</div>
	

</template>

<script>
	export default{
		data(){
			return {
				
			}
		}
	}
</script>

<style scoped>
	.custom-icon {
	  width: 220px;
	  height: 220px;
	}
	</style> 